import React from 'react';
import {CgArrowRight, CgArrowLeft} from 'react-icons/cg';
import {Save, Excel, Download, Plus, UploadImage, Done, Trash} from '../../assets/icons/icons';
import {ButtonContainer, ButtonIcon, ButtonSpan} from './styles';

export default ({
  title,
  callback,
  lColor,
  rColor,
  aColor,
  fColor = '#ffffff',
  bColor = 'transparent',
  icon,
  rIcon,
  disabled = false,
  lMargin = '0 10px',
  rMargin = '0 30px',
  xMargin = '0',
  fullWidth,
  dataCy,
  type = 'button',
  responsive,
  bradius,
  simpleButton,
  fSize,
  colorDisabled,
  fWeight
}: {
  title?: string;
  callback?: any;
  lColor?: string;
  rColor: string;
  icon?: string;
  rIcon?: string;
  lMargin?: string;
  rMargin?: string;
  fColor?: string;
  bColor?: string;
  xMargin?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  aColor?: string;
  dataCy?: string;
  responsive?: string;
  bradius?: string;
  type?: 'button' | 'submit' | 'reset';
  simpleButton?: boolean;
  colorDisabled?: string;
  fSize?: string;
  fWeight?: string;
}) => (
  <ButtonContainer 
    type={type}
    bColor={bColor} 
    data-cy={dataCy} 
    xMargin={xMargin}
    onClick={callback} 
    boradius={bradius} 
    disabled={disabled}
    colorDisabled={colorDisabled}
    style={{width: fullWidth ? '100%' : 'auto'}} 
  >
    {lColor && !simpleButton && (
      <ButtonIcon responsive={responsive} lColor={lColor} lMargin={lMargin} aColor={aColor}>
        {icon === 'save' ? (
          <Save color={fColor} />
        ) : icon === 'excel' ? (
          <Excel color={fColor} />
        ) : icon === 'plus' ? (
          <Plus />
        ) : icon === 'done' ? (
          <Done />
        ) : icon === 'trash' ? (
          <Trash color={fColor} />
        ) : icon === 'arrowLeft' ? (
          <CgArrowLeft color={fColor} fontSize="25px" />
        ) : icon === 'uploadImage' ? (
          <UploadImage />
        ) : rIcon ? (
          <ButtonSpan fColor={fColor} fWeight={fWeight}>{title}</ButtonSpan>
        ) : (
          <></>
        )}
      </ButtonIcon>
    )}

    <ButtonSpan
      fSize={fSize}
      rColor={rColor}
      fColor={fColor}
      aColor={aColor}
      rMargin={rMargin}
      boradius={bradius}
      disabled={disabled}
      fullWidth={fullWidth}
      responsive={responsive}
      colorDisabled={colorDisabled}
      fWeight={fWeight}
    >
      {!rIcon ? (
        title
      ) : (
        <>
          {rIcon === 'download' ? (
            <Download color={fColor} />
          ) : rIcon === 'arrowRight' ? (
            <CgArrowRight color={fColor} fontSize="25px" />
          ) : (
            title
          )}
        </>
      )}
    </ButtonSpan>
  </ButtonContainer>
);
